import { Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Page } from '../../../../../models/page.model';
import { Block } from '../../../../../models/block.model';
import { Component as ComponentModel } from '../../../../../models/component.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DndDropEvent } from 'ngx-drag-drop';
import { ComponentType } from '../../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../../shared/enums/input-type/input-type.module';
import { SelectType } from '../../../../../shared/enums/select-type/select-type.module';
import { UtilsService } from '../../../../../services/shared/utils/utils.service';
import { RoleType } from '../../../../../shared/enums/role-type/role-type.module';
import { ComponentsGroup } from '../../../../../models/componentGroup.model';
import { AddComponentModalComponent } from '../../../../../shared/components/add-component-modal/add-component-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { GroupConfigComponent } from './group-config/group-config.component';
import { CommonService } from '../../../../../services/shared/common/common.service';
import { OptionsType } from '../../../../../shared/enums/options-type/options-type.module';
import { Connection } from '../../../../../models/connection.model';
import { Direction } from '../../../../../shared/enums/direction/direction.module';
import { TriggerType } from '../../../../../shared/enums/trigger-type/trigger-type.module';
import { ConnectionDefinition, ConnectionDefinitionValue } from '../../../../../models/connectionDefinition.model';
import { App } from '../../../../../shared/enums/app/app.module';

@Component({
  selector: 'app-block-config',
  templateUrl: './block-config.component.html',
  styleUrl: './block-config.component.css'
})
export class BlockConfigComponent {
  @Input() page!: Page;
  @Input() block!: Block;
  @Input() activeRightSideBar!: string;
  @Input() selectedBlock!: boolean;

  @Output() groupSelected = new EventEmitter<string>();
  @Output() componentSelected = new EventEmitter<{ componentId: string, groupId: string, open?: string }>();
  @Output() newComponent = new EventEmitter<{ groupId: string, componentId: string }>();
  @Output() buildSideBarSettingsBlock = new EventEmitter;
  @Output() newUpdate = new EventEmitter;

  @Input() selectedGroupId!: string | null;
  @Input() selectedComponentId!: string | null;
  @Input() connectionsDefinitions: ConnectionDefinition[] = [];

  @ViewChildren('groupComponent') groupComponents!: QueryList<GroupConfigComponent>;
  @ViewChild('dropCards') dropCards!: ElementRef;
  @ViewChild('blockContainer') blockContainer!: ElementRef;
  @ViewChild('slideContent') slideContent!: ElementRef;
  @ViewChild('slideTitle') slideTitle!: ElementRef;
  @ViewChild('selectCard', { read: ElementRef }) selectCardRef!: ElementRef;
  @ViewChild('businessCard', { read: ElementRef }) businessCardRef!: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenuRef!: ElementRef;

  dropdownStyles: { [key: string]: string } = {};
  showDropdown = false;
  hoverTimeout: any;
  activeMenu: 'BUSINESS' | 'SELECTS' | null = null;

  dropdownStylesSelects: { [key: string]: string } = {};
  showDropdownSelects = false;

  constructor(
    private utils: UtilsService,
    private dialog: MatDialog,
    public translationService: TranslationService,
    private commonService: CommonService,
    private renderer: Renderer2
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.commonService.adjustAddComponentWidth(this.renderer);
  }

  onSelectGroup(event: MouseEvent, group: ComponentsGroup) {
    event.stopPropagation();
    var groupId = group.id;
    if(group.components.length > 1)
    {
      if(groupId !== this.selectedGroupId || this.selectedComponentId !== null)
      {
        this.groupSelected.emit(groupId);
      }
    }
    else{
      var componentId = group.components[0].id;
      this.componentSelected.emit({ componentId, groupId });
    }
  }

  onSelectComponent(componentId: string, groupId: string, open?: string) {
    this.componentSelected.emit({ componentId, groupId, open });
  }

  //update(reorder)
  dropGroup(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.block.componentGroups, event.previousIndex, event.currentIndex);
    this.updateComponentOrder();
    this.newUpdate.emit();
  }

  updateComponentOrder(): void {
    this.block.componentGroups.forEach((group, index) => {
      group.order = index + 1;
    });
  }

  //create
  dropOnBlock(event: DndDropEvent): void {
    this.createGroupWithComponent(event.data['type']);
  }

  dropOnGroup(event: DndDropEvent, groupId: string): void {
    this.createComponentOnGroup(event.data['type'], groupId);
  }

  dropBetweenGroups(event: DndDropEvent, index: number|undefined = undefined): void {
    this.activeDropIndex = null;
    const type = event.data['type'];
    if (type) {
      this.createGroupWithComponent(type, index);
    }
  }

  activeDropIndex: number | null = null;
  onDragEnter(event: DragEvent, index: number): void {
    event.preventDefault();
    this.activeDropIndex = index;
  }
  onDragLeave(event: DragEvent, index: number): void {
    event.preventDefault();
    if (this.activeDropIndex === index) {
      this.activeDropIndex = null;
    }
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  reorderGroups()
  {
    this.block.componentGroups = this.block.componentGroups.sort((groupA, groupB) => {
      if (groupA.order === undefined && groupB.order !== undefined) {
        return -1;
      } else if (groupA.order !== undefined && groupB.order === undefined) {
        return 1;
      } else if (groupA.order === undefined && groupB.order === undefined) {
        return 0;
      } else {
        return groupA.order! - groupB.order!;
      }
    });
  }

  onAddNewComponent(type: string): void{
    const groupsInfo = this.block.componentGroups.map(group => {

      var selectTitle = '';
      if(group.title)
      {
        selectTitle = group.title;
      }
      else{
        const firstComponent = group.components.find(x => x.order === 0);
        selectTitle = firstComponent ? (firstComponent.title ? firstComponent.title : '') : '';
      }

      return {
        id: group.id,
        title: selectTitle,
        freeSpace: 12 - group.components.reduce((sum, component) => sum + (component.size || 0), 0),
        selected: (this.selectedGroupId == group.id)
      };
    });

    if(groupsInfo.length == 0)
    {
      this.createGroupWithComponent(type);
      return;
    }

    const dialogRef = this.dialog.open(AddComponentModalComponent, {
      width: '500px',
      data: {
        groupsInfo: [...new Set(groupsInfo)]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var groupId:string = result.selectedGroupId;

        if(groupId){
          this.createComponentOnGroup(type, groupId);
        }
        else{
          this.createGroupWithComponent(type);
        }
      }
    });
  }

  buildNewComponent(type: string, order: number): ComponentModel{
    var selectedType: ComponentType = ComponentType.INPUT;
    var selectedSubTypeInput: InputType | null = null;
    var selectedSubTypeSelect: SelectType | null = null;
    const componentId = this.utils.generateGUID();

    var connectionDefinition = this.connectionsDefinitions.find(cd => cd.app == App.CONTENT);
    var connectionDefinitionValue: ConnectionDefinitionValue[] | undefined = undefined;

    switch (type) {
      case 'INPUT_TEXT':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.TEXT;
        break;
      case 'TEXT_AREA':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.TEXT_AREA;
        break;
      case 'NUMBER':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.NUMBER;
        break;
      case 'DATE':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.DATE;
        break;
      case 'COLOR':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.COLOR_PICKER;
        break;
      case 'FILE':
        selectedType = ComponentType.INPUT;
        selectedSubTypeInput = InputType.FILE;
        break;
      case 'LIST_DROP':
        selectedType = ComponentType.SELECT;
        selectedSubTypeSelect = SelectType.LIST_DROP;
        break;
      case 'LIST_NO_DROP':
        selectedType = ComponentType.SELECT;
        selectedSubTypeSelect = SelectType.LIST_NO_DROP;
        break;
      case 'LIST_CARD':
        selectedType = ComponentType.SELECT;
        selectedSubTypeSelect = SelectType.LIST_CARD;
        break;
      case 'CHECKBOX':
        selectedType = ComponentType.CHECKBOX;
        break;
      case 'SCHEDULE':
        selectedType = ComponentType.SCHEDULE;
        connectionDefinition = this.connectionsDefinitions.find(cd => cd.app == App.CONTENT);
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "horaire");
        }
        break;
      case 'BUTTON':
        selectedType = ComponentType.BUTTON;
        break;
      case 'TEXT':
        selectedType = ComponentType.TEXT;
        break;
      case 'TITLE':
        selectedType = ComponentType.TITLE;
        break;
      case 'HTML':
        selectedType = ComponentType.HTML;
        break;
      case 'ADDRESS':
        selectedType = ComponentType.ADDRESS;
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "adresse");
        }
        break;
      case 'INTITULE':
        selectedType = ComponentType.INTITULE;
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "intitule");
        }
        break;
      case 'URL':
        selectedType = ComponentType.URL;
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "url");
        }
        break;
      case 'VISUAL_PUBLICATION':
        selectedType = ComponentType.VISUAL_PUBLICATION;
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "visuel_parution");
        }
        break;
      case 'ACTIVITY_PRESTATIONS':
        selectedType = ComponentType.ACTIVITY_PRESTATIONS;
        if(connectionDefinition)
        {
          connectionDefinitionValue = connectionDefinition?.values?.filter(x => x.parsing == "activite" || (x.parsing == "expression" && x.name == "prestation"));
        }
        break;
    }

    var connections: Connection[] = [];
    if(connectionDefinition && connectionDefinitionValue)
    {
      connections.push({
        id: this.utils.generateGUID(),
        connectionDefinition: {
          id: connectionDefinition.id,
          app: connectionDefinition.app,
          endpoints: connectionDefinition.endpoints,
          ...(connectionDefinition.app !== App.CDC && {
            values: connectionDefinitionValue?.map(v => ({
              id: v.id,
              handle: v.handle,
              operations: v.operations
            }))
          })
        },
        direction: selectedType == ComponentType.ADDRESS || selectedType == ComponentType.INTITULE ? Direction.IN : Direction.IN_OUT,
        trigger: TriggerType.DYNAMIC
      });
    }

    const newComponent : ComponentModel = {
      id: componentId,
      title: this.translationService.translate('Empty'),
      type: selectedType,
      tag: "",
      exportTag: "",
      order: order,
      conditions: [],
      isRequired: false,
      readOnly: false,
      regex: "",
      size: 12,
      columns: 1,
      roles: [
        {
          name: RoleType.DELIVERY,
          isActive: false,
          accessibility: {
            visible: this.block.roles.find(x => x.name == RoleType.DELIVERY)!.accessibility.visible,
            editable: this.block.roles.find(x => x.name == RoleType.DELIVERY)!.accessibility.editable
          }
        },
        {
          name: RoleType.CLIENTSERVICE,
          isActive: false,
          accessibility: {
            visible: this.block.roles.find(x => x.name == RoleType.CLIENTSERVICE)!.accessibility.visible,
            editable: this.block.roles.find(x => x.name == RoleType.CLIENTSERVICE)!.accessibility.editable
          }
        },
        {
          name: RoleType.SALES,
          isActive: false,
          accessibility: {
            visible: this.block.roles.find(x => x.name == RoleType.SALES)!.accessibility.visible,
            editable: this.block.roles.find(x => x.name == RoleType.SALES)!.accessibility.editable
          }
        },
        {
          name: RoleType.CUSTOMER,
          isActive: false,
          accessibility: {
            visible: this.block.roles.find(x => x.name == RoleType.CUSTOMER)!.accessibility.visible,
            editable: this.block.roles.find(x => x.name == RoleType.CUSTOMER)!.accessibility.editable
          }
        },
        {
          name: RoleType.INTERN,
          isActive: false,
          accessibility: {
            visible: this.block.roles.find(x => x.name == RoleType.INTERN)!.accessibility.visible,
            editable: false
          }
        }
      ],
      connections: connections,
      keyIndicator: {
        weight: 0
      },
      config: {
        inputType: selectedType == ComponentType.INPUT && selectedSubTypeInput !== null ? selectedSubTypeInput : undefined,
        selectType: selectedType == ComponentType.SELECT && selectedSubTypeSelect !== null ? selectedSubTypeSelect : undefined,
        placeholder: selectedType == ComponentType.BUTTON ? "Cliquer" : "",
        text: selectedType == ComponentType.HTML ? '<span style="font-size: small;">' + this.translationService.translate('Empty') + '</span>' : ComponentType.CHECKBOX ? this.translationService.translate('Empty') : "",
        multipleAnswers: connections?.some(x => x.connectionDefinition?.values?.some(y => y.handle == "MULTIPLE")) && selectedType != ComponentType.ACTIVITY_PRESTATIONS,
        optionsType: selectedType == ComponentType.SELECT ? OptionsType.CUSTOM : undefined,
        options: [],
        hasColorText: selectedType == ComponentType.INPUT && selectedSubTypeInput == InputType.COLOR_PICKER ? false : undefined,
        contentAPISubType: selectedType == ComponentType.URL ? "CUSTOM" : selectedType == ComponentType.VISUAL_PUBLICATION ? "PHOTO" : undefined,
        fileType: selectedType == ComponentType.VISUAL_PUBLICATION ? ["IMAGE"] : undefined,
        mask: selectedType == ComponentType.INPUT && selectedSubTypeInput == InputType.TEXT ? {
          type: "NONE",
          mask: "",
          dropSpecialCharacters: false
        } : undefined
      },
      multipleConfig: {
        initQuantity: 1,
        minQuantity: 1,
        maxQuantity: connections?.some(x => x.connectionDefinition?.values?.some(y => y.handle == "MULTIPLE"))
                      && selectedType != ComponentType.ACTIVITY_PRESTATIONS ? undefined : 1,
        textBtnMultiple: "",
        haveIndexTitles: false
      }
    };

    return newComponent;
  }

  createGroupWithComponent(type: string, index: number | undefined = undefined){
    //create component
    var newComponent = this.buildNewComponent(type, 0);
    //create group
    var groupOrder = 0;
    if(index !== undefined)
    {
      var groupOrder = index;
      this.block.componentGroups.filter(group => group.order != undefined && group.order >= index).forEach(group => {
        group.order = group.order! +1;
      });
    }
    else {
      const groupWithMaxOrder =
      this.block.componentGroups.length > 0 ?
        this.block.componentGroups.reduce((prev, current) => (prev.order! > current.order!) ? prev : current).order
      : -1;
      var groupOrder = groupWithMaxOrder! +1;
    }


    var newGroup = this.commonService.buildNewGroup(groupOrder);
    //push to group/block
    newGroup.components.push(newComponent);
    this.block.componentGroups.push(newGroup);

    if(index != undefined)
    {
      this.reorderGroups();
    }

    var groupId = newGroup.id;
    var componentId = newComponent.id;

    const componentIndex = newGroup.components.findIndex(component => component.id === componentId);
    this.newComponent.emit({ groupId, componentId });
  }

  createComponentOnGroup(type: string, groupId: string){
    //fetch group
    var groupTarget = this.block.componentGroups.find(x => x.id === groupId);
    if(groupTarget)
    {
      //get group order
      const componentWithMaxOrder = groupTarget.components.reduce((prev, current) => (prev.order! > current.order!) ? prev : current);
      var componentOrder = componentWithMaxOrder ? componentWithMaxOrder.order! +1 : 0;
      //create component
      var newComponent: ComponentModel = this.buildNewComponent(type, componentOrder);

      //push to group
      groupTarget.components.push(newComponent);

      var componentId = newComponent.id;
      this.newComponent.emit({ groupId, componentId });
    }
  }

  adjustGroupComponentsSize(group: ComponentsGroup){

    //get qt components
    var qtComponents = group.components.length;
    //get spaces
    const baseSize = Math.floor(12 / qtComponents);
    let remainingSize = 12 - (baseSize * qtComponents);

    //adjust sizes
    group.components.forEach((component, index) => {
      if (remainingSize > 0) {
          component.size = baseSize + 1;
          remainingSize--;
      } else {
          component.size = baseSize;
      }
    });
  }


  buildSideBarSettings(){
    this.buildSideBarSettingsBlock.emit();
  }


  scrollToComponent(groupId: string, componentIndex: number) {
    const groupComponent = this.groupComponents.find(group => group.componentsGroup.id === groupId);
    groupComponent?.scrollToComponent(componentIndex);
  }

  canAddGroup(componentsGroup: ComponentsGroup): boolean{
    return componentsGroup.multipleConfig!.maxQuantity === null || componentsGroup.multipleConfig!.maxQuantity === undefined || componentsGroup.multipleConfig!.maxQuantity > 1;
  }

  hoveredGroupId: string | null = null;

  onMouseEnter(groupId: string) {
    this.hoveredGroupId = groupId;
  }

  onMouseLeave(groupId: string) {
    if (this.hoveredGroupId === groupId) {
      this.hoveredGroupId = null;
    }
  }

  afterReorderComponents()
  {
    this.newUpdate.emit();
  }

  menuConfigs = {
    BUSINESS: [
      { type: 'SCHEDULE', icon: 'schedule', label: 'SCHEDULE' },
      { type: 'ADDRESS', icon: 'location_on', label: 'ADDRESS' },
      { type: 'INTITULE', icon: 'person', label: 'Intitulé' },
      { type: 'URL', icon: 'http', label: 'URL' },
      { type: 'VISUAL_PUBLICATION', icon: 'image', label: 'VISUAL_PUBLICATION' },
      { type: 'ACTIVITY_PRESTATIONS', icon: 'business_center', label: 'ACTIVITY_PRESTATIONS' }
    ],
    SELECTS: [
      { type: 'LIST_DROP', icon: 'list_alt', label: 'LIST_DROP' },
      { type: 'LIST_NO_DROP', icon: 'format_list_bulleted', label: 'LIST_NO_DROP' },
      { type: 'LIST_CARD', icon: 'grid_view', label: 'LIST_CARD' }
    ]
  };

  get activeMenuItems() {
    return this.activeMenu ? this.menuConfigs[this.activeMenu] : [];
  }

  onEnterMenu(menuType: 'BUSINESS' | 'SELECTS') {
    clearTimeout(this.hoverTimeout);
    this.activeMenu = menuType;
    setTimeout(() => this.positionMenu(), 0);
  }

  onLeaveMenu() {
    this.hoverTimeout = setTimeout(() => {
      this.activeMenu = null;
    }, 100);
  }

  positionMenu() {
    if (!this.activeMenu) return;

    const isBusiness = this.activeMenu === 'BUSINESS';
    const cardRef = isBusiness ? this.businessCardRef : this.selectCardRef;
    const menuRef = this.dropdownMenuRef;

    const dropCardsRect = (this.dropCards.nativeElement as HTMLElement).getBoundingClientRect();
    const cardRect = (cardRef.nativeElement as HTMLElement).getBoundingClientRect();
    const paddingLeft = parseFloat(window.getComputedStyle((menuRef.nativeElement as HTMLElement)).paddingLeft);
    const zoom = this.utils.getRootZoom();

    const styles = {
      left: `${(cardRect.left - dropCardsRect.left - paddingLeft) / zoom}px`,
      top: `${dropCardsRect.height / zoom}px`
    };

    if (isBusiness) this.dropdownStyles = styles;
    else this.dropdownStylesSelects = styles;
  }

}
